/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector, useDispatch } from 'react-redux';
// material
import MenuItem from './menuitem/menuitem';
// actions
import { signOut } from '../../../../../state/thunks/session';
// styles
import injectSheet from 'react-jss';
import styles from './menu_styles';

import {
	PRODUCT_COMMENTING,
} from "../../../../../state/thunks/account";


/* ========== ~~~~~~~~~~ MENU ~~~~~~~~~~ ========== */
const Menu = injectSheet(styles)((props) => {
	const userMenuOpen = useSelector(state => state.app.userMenuOpen);
	const { mocked, autoLoginPubPortalV2, userEmail } = useSelector(state => state.session);
	const dispatch = useDispatch();

	const isLogoutDisabled = mocked || !autoLoginPubPortalV2;
	{/* temporarily hiding page if user doesn't have commenting This will be removed when
			more sections are added to the page and the sections will individually be hidden by appropriate permissions*/}
	const { accountProducts } = useSelector((state) => state.account);
	const hasCommenting = accountProducts?.includes(PRODUCT_COMMENTING)


	return (
		<div id="usermenu" className={`${props.classes.menu} userMenuOpen-${userMenuOpen}`} disabled={true}>
			<MenuItem icon={'cog'} text={'My Account'} route={'/profile/account'} disabled={true} />
			{/* temporarily limiting this page to admins and hiding it if user doesn't have commenting,
			since the only items on the page require those to be true right now. This logic will be removed when
			more sections are added to the page */}
			<MenuItem icon={'building'} text={'Company'} route={'/profile/company'} disabled={!( mocked && hasCommenting)} />
			<MenuItem icon={'question'} text={'Help'} route={'/profile/help'} disabled={true} />
			<MenuItem icon={'sign-out-alt'} text={'Logout'} handleOnClick={() => dispatch(signOut())} disabled={isLogoutDisabled} />
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Menu;
